import { render, staticRenderFns } from "./subcontractingResources.vue?vue&type=template&id=3addcafc&scoped=true&"
import script from "./subcontractingResources.vue?vue&type=script&lang=js&"
export * from "./subcontractingResources.vue?vue&type=script&lang=js&"
import style0 from "./subcontractingResources.vue?vue&type=style&index=0&id=3addcafc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3addcafc",
  null
  
)

export default component.exports